'use client';

import React from 'react';
import { GiftSelectionPrompt } from '@/nova/modules/cart/components';
export interface CartHeaderProps {
    isMobile?: boolean;
}

/**
 * CartHeader - Cart header component with gift selection prompt and progress bar
 * Matches mobile module-theme-hermes implementation
 */
export const CartHeader: React.FC<CartHeaderProps> = ({ isMobile }) => {
    return (
        <>
            <GiftSelectionPrompt isMobile={isMobile} />
            {/*Temporary ignore this block due to BRD clearly */}
            {/*<GiftProgressBar isMobile={isMobile} />*/}
        </>
    );
};
